export { default } from './UpdateStockMerchant';
